import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { northLasVegasConfig } from "./data";

export default function NorthLasVegasPage() {
  return <CityPageTemplate config={northLasVegasConfig} />;
}